/**
 * The type of child component.
 */
export var ChildComponentType;
(function (ChildComponentType) {
    /**
     * In window component(JavaScript or WebComponent Custom Element)
     */
    ChildComponentType["InWindow"] = "inWindow";
    /**
     * Cross window component(loaded in an emendable element - Iframe)
     */
    ChildComponentType["CrossWindow"] = "crossWindow";
})(ChildComponentType || (ChildComponentType = {}));
//# sourceMappingURL=childComponentType.js.map